/* eslint-disable import/extensions */

// Polyfill for React 18's `useId`, aliased in place of the bare `react` specifier
// (see config-overrides.js). Some ESM dependencies (e.g. react-shiki, react-json-view-lite,
// pulled in via @engyalo/conversation-explorer-ui) statically `import { useId } from 'react'`,
// which fails to compile against React 17. This app is client-rendered only (no SSR), so a
// ref-memoized counter is a valid stand-in for React 18's hydration-safe useId.
//
// Import the real react via its file path, not the bare specifier, so the `react$` alias
// in config-overrides.js doesn't redirect this import back to this same shim.
import * as React from 'react/index.js';

export default React;
export * from 'react/index.js';

let idCounter = 0;

export function useId() {
  const idRef = React.useRef();
  if (idRef.current === undefined) {
    idCounter += 1;
    idRef.current = `sd-uid-${idCounter}`;
  }
  return idRef.current;
}
